// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../../node_modules/systemjs-webpack-interop/auto-public-path/1.js");
let __webpack_exports__ = __webpack_require__("../../integrated-teams/jira-pulsar/browser/src/jira-issueview-quickactions/ui/index.tsx");
